// extracted by mini-css-extract-plugin
export default {"products":"pr-z","card":"qr-z","oosMessaging":"rr-z"};